import React, { useState, useEffect } from 'react';
import { useTx } from '../hooks/useTx';
import { useWeb3 } from '../context/Web3Context';
import { DEFAULT_REFERRER, PACKAGES, ALL_PACKAGES_TOTAL } from '../config/contracts';

export default function Register({ onRegistered }) {
  const { run, pending, stage } = useTx();
  const { account } = useWeb3();
  const [ref, setRef] = useState('');

  // Prefill referrer from ?ref= in the URL (referral links).
  useEffect(() => {
    try {
      const params = new URLSearchParams(window.location.search);
      const r = params.get('ref');
      if (r && /^\d+$/.test(r)) setRef(r);
    } catch {
      /* ignore */
    }
  }, []);

  const referrerId = ref && /^\d+$/.test(ref) ? ref : DEFAULT_REFERRER;
  const starter = PACKAGES[0].price;

  const doRegister = () =>
    run({
      method: 'register',
      args: [referrerId],
      approveAmount: starter,
      successMsg: 'Welcome to Evitta! You are registered.',
      onDone: onRegistered,
    });

  const doRegisterAll = () =>
    run({
      method: 'registerWithAllPackages',
      args: [referrerId],
      approveAmount: ALL_PACKAGES_TOTAL,
      successMsg: 'All packages activated! Welcome to Evitta.',
      onDone: onRegistered,
    });

  const label =
    stage === 'approve'
      ? 'Approving USDT…'
      : stage === 'confirm'
      ? 'Confirm in wallet…'
      : stage === 'mining'
      ? 'Processing…'
      : null;

  return (
    <div className="tab fade-in">
      <div className="card glow" style={{ marginTop: 18 }}>
        <h2 className="gold-text" style={{ fontSize: 22 }}>Join Evitta</h2>
        <p className="muted" style={{ fontSize: 13, marginTop: 6 }}>
          Enter a referrer ID to get started. Leave blank to join under the default sponsor.
        </p>

        <div className="field">
          <label>Referrer ID</label>
          <input
            inputMode="numeric"
            placeholder={`Default (${DEFAULT_REFERRER})`}
            value={ref}
            onChange={(e) => setRef(e.target.value.replace(/[^\d]/g, ''))}
          />
        </div>

        <div style={{ marginTop: 18 }}>
          <button className="btn" onClick={doRegister} disabled={pending}>
            {pending ? <span className="spin-inline" /> : null}
            {label || `Register · Starter $${starter}`}
          </button>
        </div>

        <div style={{ marginTop: 12 }}>
          <button className="btn blue" onClick={doRegisterAll} disabled={pending}>
            {pending ? <span className="spin-inline light" /> : null}
            {label || `Join with ALL Packages · $${ALL_PACKAGES_TOTAL}`}
          </button>
        </div>

        <p className="dim" style={{ fontSize: 11.5, marginTop: 14, textAlign: 'center' }}>
          Connected as {account ? account.slice(0, 6) + '…' + account.slice(-4) : '—'}
        </p>
      </div>

      <div className="section-title"><span className="bar" />What you get</div>
      <div className="card">
        <ul style={{ listStyle: 'none', display: 'grid', gap: 12 }}>
          <Benefit t="Sponsor & Level income" d="Earn from direct referrals and 12 matrix levels." />
          <Benefit t="4 reward pools" d="Silver, Gold, Diamond & Special bonus pools." />
          <Benefit t="Upgrade anytime" d="Unlock all 9 packages and grow your ceiling." />
        </ul>
      </div>
    </div>
  );
}

function Benefit({ t, d }) {
  return (
    <li style={{ display: 'flex', gap: 12 }}>
      <span className="act-ic" style={{ color: '#f5c518' }}>★</span>
      <div>
        <div style={{ fontWeight: 600, fontSize: 14 }}>{t}</div>
        <div className="dim" style={{ fontSize: 12 }}>{d}</div>
      </div>
    </li>
  );
}
